import "core-js/stable"
import "regenerator-runtime/runtime"


import $ from 'jquery';
window.jQuery = $
window.$ = $

import crel from 'crel'
window.crel = crel

import '../external/bootstrap/js/bootstrap.min'
import '../external/bootstrap-datepicker/js/bootstrap-datepicker'
import '../external/bootstrap-datepicker/locales/bootstrap-datepicker.sl.min'
import 'materialize-css'
import './materialize_init'
import './defer_loading_images'
import '../../store/order/form/form'
import '../../store/order/order_address_add'
import '../../store/order/order'
import  './braintree_tools'
import  './waiting_modal'
import './didomi'

import '../scss/style.scss'

const urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results) {
        return results[1] || 0;
    } else {
        return 0;
    }
}

window.addEventListener('load', (event) => {
    if(typeof ga == 'undefined') return
    if (window.adBlocker === undefined) {
        console.log('Ad blocker is ON (Yes)')
        ga('send', {
            hitType: 'event',
            eventCategory: 'Adblocker',
            eventAction: 'Yes',
            eventLabel: window.location.href
        });
    } else {
        console.log('Ad blocker is OFF (No)')
        ga('send', {
            hitType: 'event',
            eventCategory: 'Adblocker',
            eventAction: 'No',
            eventLabel: window.location.href
        });
    }
});

$(function () {

    // utility to get URL param
    $.urlParam = function (name) {
        var results = new RegExp('[\?&amp;]' + name + '=([^&amp;#]*)').exec(window.location.href);
        return results[1] || 0;
    }

    /*
     * Fade out page messages
     */
    $(".ella-message-off-button").on('click', function (event) {
        event.preventDefault();
        $(this).parent().parent().css({opacity: 0, transition: 'opacity 0.5s'}).slideUp();
    });

    /*
     * Date field
     */
    $(".input-group.date").datepicker({
        language: 'sl',
        weekStart: 1,
        format: 'dd.mm.yyy',
        todayHighlight: true,
        autoclose: true
    });
    $(".input-group.date")

    /*
     * ella-second-level-tabs
     */
    $('.ella-second-level-tabs a').click(function (e) {
        e.preventDefault()
        $(this).tab('show')
    });
    if (urlParams.tab) {
        $('.ella-second-level-tabs li a[href="#' + urlParams.tab + '"]').tab('show')
    }


    /*
     * Redirect payments to post
     */
    // $('#ella-redirect-payment form').submit();


    /*
     * Ella timed redirect.
     *
     * urlParams.ella_timed_redirect (path in url)
     * urlParams.delay (in seconds)
     */
    if (urlParams.ella_timed_redirect) {
        var delay = urlParams.delay ? parseInt(urlParams.delay) : 10;
        setTimeout(function () {
            window.location.href = urlParams.ella_timed_redirect;
        }, delay * 1000);
    }

    /*
     * Turn on a special PAYPAL notice when selecting paypal
     */
    $('#ella-order-payment-form').on('change', function() {
        var val = $('input[name=payments]:checked', '#ella-order-payment-form').val();
        if(val=='paypal') {
            $('#ella-paypal-redirect-notice').removeClass('hidden');
        } else {
            $('#ella-paypal-redirect-notice').addClass('hidden');
        }
    });


    /*
     * Address form postal code map.
     *
     */
    $('#ella-address-form').each(function () {
        var form = $(this);
        var iso2 = $('.form-control.country option:selected').attr('iso2');
        var i_code = $('input.form-control.postal_code', this);
        var i_city = $('input.form-control.city', this);
        var i_country = $('select.form-control.country', this);

        // This will hold country data
        var data = {}

        // Hide company portion of the address if initial country is not Slovenia
        iso2 == 'SI' ?  $('.ella-company-address').show():  $('.ella-company-address').hide();

        $.get('/static/country_postal_codes/' + iso2 + '.txt', function (text) {
            data = jsonify_postal_data(text);

            set_code_matching(i_city, data.cities);
            set_code_matching(i_code, data.codes);

            i_city.on('input blur', function() {
                var value = $(this).val();
                if ( value.length>1 && 'city_to_code' in data &&  data['city_to_code'].hasOwnProperty(value)) {
                    i_code.val(data.city_to_code[$(this).val()]);
                } else {
                    i_code.val('');
                }
            });

            i_code.on('input blur', function() {
                var value = $(this).val();
                if (value.length>1 && 'code_to_city' in data &&  data['code_to_city'].hasOwnProperty(value)) {
                    i_city.val(data.code_to_city[$(this).val()]);
                } else {
                    i_city.val('');
                }
            });

        });

        i_country.on('change', function () {
            var iso2 = $('.form-control.country option:selected').attr('iso2');
            // Hide company portion of the address if initial country is not Slovenia
            iso2 == 'SI' ?  $('.ella-company-address').show():  $('.ella-company-address').hide();
            $.get('/static/country_postal_codes/' + iso2 + '.txt', function (text) {
                data = jsonify_postal_data(text);
                i_city.typeahead('destroy');
                i_code.typeahead('destroy');
                set_code_matching(i_city, data.cities);
                set_code_matching(i_code, data.codes);
            });
        });

    });

    function set_code_matching(item, data) {
        item.typeahead({
            hint: true,
            highlight: true,
            minLength: 2
        }, {
            name: '',
            source: substringMatcher(data)
        });
    }

    function set_up_post_code_matching(data) {
        ['postal_code', 'city'].forEach(function (item) {
            var match_set = item == 'city' ? data.cities : data.codes;

            $('.form-control.' + item).typeahead('destroy');

            $('.form-control.' + item).typeahead({
                hint: true,
                highlight: true,
                minLength: 2
            }, {
                name: item,
                source: substringMatcher(match_set)
            });
        });
        return data;
    }

    function jsonify_postal_data(data) {
        var out = {
            cities: [],
            codes: [],
            code_to_city: {},
            city_to_code: {}
        }
        data.split("\n").forEach(function (line) {
            var city = line.trim().split(/\s/);
            var code = city.shift();
            city = city.join(' ');
            if (code) {
                out.cities.push(city);
                out.codes.push(code);
                out.code_to_city[code] = city;
                out.city_to_code[city] = code;
            }
            ;
        });
        return out;
    }

    /*
     * Make sure If Company is specified that we have a VAT number there too
     * */
    var iso2 = $('.form-control.country option:selected').attr('iso2');
    var vat = $('#ella-address-form .vat');
    var company = $('#ella-address-form .company');
    var button = $('#ella-address-form [name="change_addresses"]');
    var taxable = $('#ella-address-form .vat_taxable')
    vat.after('\
        <ul id="ella-vat-notice" class="ella-tiny-list ella-message-bar list-group" style="display: none;">\
          <li class="list-group-item list-group-item-warning">Za podjetje morate vnesti ID za DDV.</li>\
        </ul>\
    ');
    var notice = $('#ella-vat-notice');
    var message = $('.list-group-item', notice);
    var txt = 'Za podjetje morate vnesti';
    $('#ella-address-form .company, #ella-address-form .vat, #ella-address-form .vat_taxable').bind('change paste keyup', function() {
        // Disable button untill DDV ID is not filled
        if( company.val() && !vat.val().replace(/^[A-Z]{2}/, '') ) {
            button.prop({disabled: true});
            notice.css({display: 'block'});
            // Always set all as if taxable[0].checked was not checked
            vat.val(vat.val().replace(/^[A-Z]{2}/i, ''));
            message.text(txt+' davčno številko.')
            vat.prev().text('Davčna številka:')
            // If taxable[0].checked then change to different values
            if (taxable[0].checked) {
                vat.val(iso2+vat.val());
                message.text(txt+' ID za DDV.')
                vat.prev().text('ID za DDV:')
            }
        } else {
            button.prop({disabled: false});
            notice.css({display: 'none'});
        }
    });

});


/* ------------------------------------------------------------------------- */
/*
 * Get all url parameters to use with JS
 */
var urlParams;
(window.onpopstate = function () {
    var match,
        pl = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
            return decodeURIComponent(s.replace(pl, " "));
        },
        query = window.location.search.substring(1);

    urlParams = {};
    while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);
})();

/*
 * Substring matcher for typeahead
 * https://twitter.github.io/typeahead.js/
 */
function substringMatcher(strs) {
    return function findMatches(q, cb) {
        var matches, substringRegex;

        // an array that will be populated with substring matches
        matches = [];

        // regex used to determine if a string contains the substring `q`
        substrRegex = new RegExp(q, 'i');

        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        $.each(strs, function (i, str) {
            if (substrRegex.test(str)) {
                matches.push(str);
            }
        });

        cb(matches);
    };
};

